import { Button, Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTranslation } from "react-i18next";

function useWidth() {
  const theme = useTheme();
  const keys = [...theme.breakpoints.keys].reverse();
  return (
    keys.reduce((output, key) => {
      // eslint-disable-next-line
      const matches = useMediaQuery(theme.breakpoints.up(key));
      return !output && matches ? key : output;
    }, null) || "xs"
  );
}
function LeftTheRoom({ roomId, withError: leaveRoomWithError, handleLeaveFromRoom,type }) {
  const width = useWidth();
  const { t } = useTranslation();
  const layouts = { xl: 32, lg: 24, md: 24, sm: 16, xs: 12 };
  const [timer, setTimer] = useState(10);
  const [showButtons, setShowButtons] = useState(true); // New state to hide buttons

  useEffect(() => {
    handleLeaveFromRoom();

    const countdown = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(countdown);
          setShowButtons(false); // Hide buttons after 10 seconds
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(countdown);
  }, []);

  const sendMessageToParent = () => {
    console.log("hello");
    window.parent.postMessage({ type: "buttonClicked", data: "Button was clicked!", roomId }, "*");
    if(type === 'user'){
    window.parent.postMessage({ type: "homeClicked", data: "Button was clicked!" }, "*");

    }
  };
  const parentHomePageRoute = () => {
    console.log("hello");
    window.parent.postMessage({ type: "buttonClicked", data: "Button was clicked!", roomId }, "*");

    window.parent.postMessage({ type: "homeClicked", data: "Button was clicked!" }, "*");
  };
  return (
    <>
      <Grid container justifyContent={"center"} sx={{ mt: layouts[width] }}>
        <Box>
          <Box py={2}>
            <Typography variant="h6" align="center" color="white">
              {t("Redirecting in")} {timer} {t("seconds...")}
            </Typography>
          </Box>
          <Typography variant="h5" align="center">{leaveRoomWithError !== null ? t("Something Went Wrong") : t("You have left the meeting")}</Typography>
          <Box py={2}>
            <Typography variant="h7" align="center">
              {leaveRoomWithError !== null ? t(leaveRoomWithError) : ""}
            </Typography>
          </Box>
          <Box py={2}>
            <Typography variant="h6" align="center">
              {t("You can rejoin the meeting, or return to the home page.")}
            </Typography>
          </Box>
          {/* <Box py={2}>
            <Typography variant="h6" align="center" color="primary">
              {t("Redirecting in")} {timer} {t("seconds...")}
            </Typography>
          </Box> */}
        </Box>
   
   
        {/* Buttons (Hidden after 10 seconds) */}
        {showButtons ?(
          <Grid container justifyContent={"center"} spacing={2} sx={{ mt: 2 }} alignItems="center">
            <Grid item lg={1} md={3} sm={2} xs={3}>
              <Button fullWidth color="secondary" variant="outlined" onClick={() => window.location.reload()}>
                {t("Rejoin")}
              </Button>
            </Grid>
            <Grid item lg={1} md={3} sm={2} xs={3}>
              <Button  fullWidth color="secondary" variant="outlined" onClick={sendMessageToParent}>
                {t("End Call")}
              </Button>
            </Grid>
          </Grid>
        ):
        <Grid container justifyContent={"center"} spacing={2} sx={{ mt: 2 }} alignItems="center">
        {type === 'user' && 
        <Grid item lg={1} md={3} sm={2} xs={3}>
          <Button  fullWidth color="secondary" variant="outlined"onClick={() => {
            if(type === 'user'){
              parentHomePageRoute()
            }
          }}>
            Home
          </Button>
        </Grid>}
        
      </Grid>
        }
      </Grid>
    </>
  );
}

export default LeftTheRoom;
